import React, { useEffect } from 'react'

const ScrollToUpMount = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}

export default ScrollToUpMount